import React, { Component } from "react";
import _ from "lodash";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: {},
      status: "status" in props ? props.status : "login"
    };
  }

  componentWillReceiveProps(nextProps) {
    let newState = {};
    if (!_.isEqual(nextProps.status, this.props.status)) {
      newState["status"] = nextProps.status;
    }
    if (!_.isEqual(nextProps.content, this.props.content)) {
      newState["content"] = nextProps.content;
    }
    this.setState(newState);
  }

  createMarkup(content) {
    return { __html: content };
  }

  render() {
    return (
      <div className="container h-100">
        <div className="justify-content-center align-items-center row h-100">
          <div className="col-sm-12 col-md-8 col-lg-6 col-xl-6 loginMgmt">
            {"logo" in this.props.application ? (
              <p>
                <img
                  src={this.props.application.logo}
                  className="logo"
                  alt={this.props.application.name}
                />
              </p>
            ) : (
              <h1 className="h5">{this.props.application.name}</h1>
            )}
            {"login" in this.state.content && (
              <div
                dangerouslySetInnerHTML={this.createMarkup(
                  this.state.content.login
                )}
              />
            )}
            <div className="card">
              <div className="card-header">
                <ul className="nav nav-tabs card-header-tabs" role="tablist">
                  <li className="nav-item" role="presentation">
                    <a
                      role="tab"
                      id="tab_login"
                      aria-controls="tabpanel_login"
                      aria-selected={(this.state.status === "login") + ""}
                      className={
                        this.state.status === "login"
                          ? "nav-link active"
                          : "nav-link"
                      }
                      onClick={() => {
                        this.setState({ status: "login" });
                        return false;
                      }}
                    >
                      Login
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      role="tab"
                      id="tab_register"
                      aria-controls="tabpanel_register"
                      aria-selected={(this.state.status === "register") + ""}
                      className={
                        this.state.status === "register"
                          ? "nav-link active"
                          : "nav-link"
                      }
                      onClick={() => {
                        this.setState({ status: "register" });
                        return false;
                      }}
                    >
                      Register
                    </a>
                  </li>
                </ul>
              </div>

              <div className="card-body">
                {this.props.alertText && this.props.alertText !== "" && (
                  <div className={`alert alert-${this.props.alertType}`}>
                    {this.props.alertText}
                  </div>
                )}
                {this.state.status === "finish_password" && (
                  <form
                    onSubmit={e => {
                      this.props.finishResetPassword(this.el.value);
                      e.preventDefault();
                    }}
                  >
                    <div className="form-group">
                      <h2>Reset password</h2>
                      <label className="control-label" htmlFor="newPassword">
                        Enter your new password
                      </label>
                      <input
                        className="form-control"
                        id="newPassword"
                        rel="newPassword"
                        type="password"
                        required
                        ref={el => (this.el = el)}
                      />
                    </div>

                    <div className="row">
                      <div className="col text-right">
                        <button className="btn btn-primary" type="submit">
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                )}
                {this.state.status === "start_password" && (
                  <form
                    onSubmit={e => {
                      this.props.startResetPassword(this.el.value);
                      e.preventDefault();
                    }}
                  >
                    <div className="form-group">
                      <h2>Reset password</h2>
                      <label className="control-label" htmlFor="newEmail">
                        Enter your email address
                      </label>
                      <input
                        className="form-control"
                        id="newEmail"
                        rel="newEmail"
                        type="email"
                        required
                        ref={el => (this.el = el)}
                      />
                    </div>

                    <div className="row">
                      <div className="col text-right">
                        <button className="btn btn-primary" type="submit">
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                )}
                {this.state.status.match(/register|login/) && (
                  <div>
                    <button
                      className="btn btn-primary btn-block"
                      onClick={this.props.googleLogin}
                    >
                      Log in with Google
                    </button>
                    <button
                      style={{display: 'none'}}
                      className="btn btn-primary btn-block"
                      onClick={this.props.facebookLogin}
                    >
                      Log in with Facebook
                    </button>
                    <div
                      id="tabpanel_register"
                      aria-labelledby="tab_register"
                      aria-hidden={(this.state.status === "register") + ""}
                      role="tabpanel"
                      style={{
                        display:
                          this.state.status === "register" ? "block" : "none"
                      }}
                    >
                      <form onSubmit={this.props.registerUser}>
                        <p className="text-center mt-4">or</p>
                        <div className="form-group">
                          <label className="control-label" htmlFor="newEmail">
                            Email address
                          </label>
                          <input
                            className="form-control"
                            id="newEmail"
                            rel="newEmail"
                            type="email"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label
                            className="control-label"
                            htmlFor="newPassword"
                          >
                            Password
                          </label>
                          <input
                            className="form-control"
                            id="newPassword"
                            rel="newPassword"
                            type="password"
                            required
                          />
                        </div>
                        <div className="row">
                          <div className="col text-right">
                            <button className="btn btn-primary" type="submit">
                              Register
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div
                      id="tabpanel_login"
                      aria-labelledby="tab_login"
                      aria-hidden={(this.state.status === "login") + ""}
                      role="tabpanel"
                      style={{
                        display:
                          this.state.status === "login" ? "block" : "none"
                      }}
                    >
                      <form onSubmit={this.props.loginUser}>
                        <p className="text-center mt-4">or</p>
                        <p className="text-center">
                          Already started an application?
                        </p>
                        <div className="form-group">
                          <label className="control-label" htmlFor="email">
                            Email address
                          </label>
                          <input
                            className="form-control"
                            id="email"
                            rel="email"
                            type="email"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label className="control-label" htmlFor="password">
                            Password
                          </label>
                          <input
                            className="form-control"
                            id="password"
                            rel="password"
                            type="password"
                            required
                          />
                        </div>
                        <div className="row">
                          <div className="col">
                            <button
                              className="btn btn-link"
                              type="button"
                              onClick={() => {
                                this.setState({ status: "start_password" });
                              }}
                            >
                              Forgot password?
                            </button>
                          </div>
                          <div className="col text-right">
                            <button className="btn btn-primary" type="submit">
                              Login
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <p className="fine-print">
              <a href="https://www.obama.org/terms-conditions/" target="_blank">
                Terms &amp; Conditions
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Login.js